import { CollectionId, StoredFile } from "@genai/collection";
import { httpClient, postProcessUpsert } from "@genai/http-client";
import { FileId } from "../model";

export const fetchFile = (collectionId: CollectionId, fileId: FileId) =>
    httpClient(`/collections/${collectionId}/files/${fileId}`, {
      method: "GET",
    }).then(postProcessUpsert<StoredFile>);
